export class LocationStore{
    accuracy: string;
    address: string;
    city: string;
    fullNormalizedAddress:string;
    latitude: string;
    longitude: string;
    normalizedAddress: string;
    normalizedCity: string;
    normalizedCountry: string;
    normalizedDug: string;
    normalizedHamlet: string;
    normalizedLatitude: string;
    normalizedLongitude: string;
    normalizedHouseNumber: string;
    normalizedProvince: string;
    normalizedRegion: string;
    normalizedZip: string;
    province: string;
    region: string;
    streetViewEnabled: string;
    streetViewHeading: string;
    streetViewLatitude: string;
    streetViewLongitude: string;
    streetViewPitch: string;
    streetViewZoom: string;
    streetViewPanoId: string;
    zip: string;
    
    constructor(){
        this.accuracy = "";
        this.address = "";
        this.city = "";
        this.fullNormalizedAddress = "";
        this.latitude = "";
        this.longitude = "";
        this.normalizedAddress = "";
        this.normalizedCity = "";
        this.normalizedCountry = "";
        this.normalizedDug = "";
        this.normalizedHamlet = "";
        this.normalizedHouseNumber = "";
        this.normalizedLatitude = "";
        this.normalizedLongitude = "";
        this.normalizedProvince = "";
        this.normalizedRegion = "";
        this.normalizedZip = "";
        this.province = "";
        this.region = "";
        this.streetViewEnabled = "";
        this.streetViewHeading = "";
        this.streetViewLatitude = "";
        this.streetViewLongitude = "";
        this.streetViewPitch = "";
        this.streetViewZoom = "";
        this.streetViewPanoId = "";
        this.zip = "";
    }

}